import { render } from "./EmptyStart.vue?vue&type=template&id=766d42d1&scoped=true"
import script from "./EmptyStart.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyStart.vue?vue&type=script&setup=true&lang=js"

import "./EmptyStart.vue?vue&type=style&index=0&id=766d42d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766d42d1"],['__file',"src/components/dashbaord/start/EmptyStart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "766d42d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('766d42d1', __exports__)) {
    api.reload('766d42d1', __exports__)
  }
  
  module.hot.accept("./EmptyStart.vue?vue&type=template&id=766d42d1&scoped=true", () => {
    api.rerender('766d42d1', render)
  })

}


export default __exports__